import { useDispatch } from 'react-redux';

import './oppaTutorial.scss';

import { ArrowButton } from '../../../../components/common/ArrowButton/ArrowButton';
import { STEP_LIST_IDS } from '../../../../components/containers/StepList/stepListConstants';
import { stepListActions } from '../../../../components/containers/StepList/stepListSlice';
import { useInternationalization } from '../../../../hooks/useTranslationHook';
import { SkipIcon } from '../../../../icons/skip-icon';
import { modalActions } from '../../../../components/containers/Modal/modalSlice';
import { oppaTutorialSteps } from './oppaTutorial';

export const OppaTutorialStep4 = () => {
  const { formatMessage } = useInternationalization();
  const dispatch = useDispatch();

  const handleNextStep = () => {
    dispatch(stepListActions.nextStep({ stepListId: STEP_LIST_IDS.oppaTutorialStepList }));
  };

  const handleSkip = () => {
    dispatch(
      modalActions.openPromptModal({
        title: 'Are you sure you want to finish?',
        btnText: 'Yes, exit',
        onButtonClick: () => {
          localStorage.setItem('oppaCompletedTutorial', true);
          dispatch(
            stepListActions.setStep({
              stepListId: STEP_LIST_IDS.oppaTutorialStepList,
              stepId: oppaTutorialSteps.stepNull,
            }),
          );
          dispatch(modalActions.closeModal());
        },
      }),
    );
  };

  return (
    <div className="oppa-tutorial__blackout-step4">
      <div className="oppa-tutorial__skip" onClick={() => handleSkip()}>
        {formatMessage('Skip')}
        <SkipIcon className="oppa-tutorial__skip-icon" />
      </div>
      <div className="oppa-tutorial__descriptionBox-bottom">
        <div className="achievements-tutorial__descriptionBox-step">3/5</div>
        <div className="oppa-tutorial__descriptionBox-header">{formatMessage('Transaction status')}</div>
        <div className="oppa-tutorial__descriptionBox-description">
          {formatMessage(
            "Success, money will be on your balance soon. You could see the status of every your coins redemption in the 'Transactions'",
          )}
        </div>
      </div>
      <ArrowButton customClass={'oppa-tutorial__button-next'} onClick={handleNextStep} />
    </div>
  );
};
